import { Button } from '@/client/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface WeekNavProps {
  label: string;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  showToday: boolean;
  todayLabel?: string;
}

export function WeekNav({ label, onPrev, onNext, onToday, showToday, todayLabel = 'This week' }: WeekNavProps) {
  return (
    <div className="flex items-center gap-2">
      <Button variant="ghost" size="icon" type="button" onClick={onPrev} aria-label="Previous">
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <span className="flex-1 text-center text-sm font-medium">{label}</span>
      <Button variant="ghost" size="icon" type="button" onClick={onNext} aria-label="Next">
        <ChevronRight className="h-4 w-4" />
      </Button>
      {showToday && (
        <Button variant="outline" size="sm" type="button" onClick={onToday}>
          {todayLabel}
        </Button>
      )}
    </div>
  );
}
